module.exports = __webpack_public_path__ + "img/zoom-01.e8bb60f8.webp";